import { Tag } from 'antd'
import { colorBgBrandless, colorBlack, colorWhite } from 'src/app/themes/primaryThemeDefault'

interface TagProps {
  value: string
  icon: any
  handleClick?: (value: any) => void
  isSelect?: boolean
}

export const ReasonTag: React.FC<TagProps> = ({ value, icon, isSelect = false }) => {
  return (
    <Tag
      style={{
        background: !isSelect ? colorBgBrandless : `linear-gradient(357.33deg, #334157 1.88%, #004B91 97.44%)`,
        color: !isSelect ? colorBlack : colorWhite,
      }}
      className='reason-tag'
    >
      {icon ? <center>{icon}</center> : null}
      {value}
    </Tag>
  )
}
